import { makeDirMtx, dirMtxProduct } from "./DirMtx";
import { reverseSide } from "./Side";
export class SideReference {
    constructor(to, mtx, destSide) {
        this.to = to;
        this.mtx = mtx;
        this.destSide = destSide;
    }
    static fromOpts(toTile, fromSide, destSide, reflect) {
        return new SideReference(toTile, dirMtxProduct(makeDirMtx(-reverseSide(destSide), reflect), fromSide), destSide);
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/SideReference.ts
// module id = 15
// module chunks = 0